import React from 'react';
import { Navigate } from 'react-router-dom';

export default function SubjectsDefaultRedirectElement({
    training,
    parentUrl,
    availableUnfinishedSubjects,
    subjects,
}) {
    return training.subjects.length > 0 ? (
        <Navigate
            to={`${parentUrl}/subjects/${
                availableUnfinishedSubjects.length > 0
                    ? availableUnfinishedSubjects[0].id
                    : subjects[0].id
            }`}
        />
    ) : null;
}


